angular.module('PatientApp').factory('FullstoryService', [
    '$window', '$log',
    function($window, $log) {
        return {
            /**
             * Log to the Fullstory console
             * @param {String} optionalLogLevel the log level passed to Fullstory; one of 'log', 'warn', 'error', 'info'; defaults to 'log'
             * @param {String} logMessage the log message sent to the Fullstory console
             */
            log: function(optionalLogLevel, logMessage) {
                var FS;
                if (typeof logMessage === 'undefined') {
                    logMessage = optionalLogLevel;
                    optionalLogLevel = 'log';
                }
                if (!(FS = getFullstory())) {
                    $log.warn('FullstoryService: Fullstory is not initialized; cannot log to FS console properly. Log output appears below');
                    $log[optionalLogLevel](logMessage);
                } else {
                    FS.log(optionalLogLevel, logMessage);
                }
            },
            /**
             * Identify the current patient-user to Fullstory
             * @param {Object} currentUser the current patient-user
             * @returns {Boolean} indicates whether user was identified to Fullstory
             */
            identify: function (currentUser) {
                var FS, displayName;
                if (!(FS = getFullstory())) {
                    $log.warn('FullstoryService: Fullstory is not initialized; cannot identify user to Fullstory');
                    return false;
                }
                if (!(currentUser && currentUser.patientUserId)) {
                    $log.info('FullstoryService: currentUser is null; disassociating from Fullstory');
                    FS.identify(null);
                } else {
                    displayName = 'Patient User ' + currentUser.patientUserId;
                    FS.identify(currentUser.patientUserId, {
                        displayName: displayName,
                        newUser: currentUser.newUser
                    });
                    $log.info('FullstoryService: identified user to Fullstory as ' + displayName);
                }
                return true;
            }
        };
        function getFullstory() {
            if (!$window._fs_namespace) {
                return false;
            }
            return $window[$window._fs_namespace];
        }
    }
]);
